<template>
  <span :class="classNames" role="status" :aria-label="label" />
</template>

<script>
// Busy indicator. `inline` is the in-button size, which inherits the button's
// own colour rather than the brand colour.

export default {
  name: 'DsSpinner',
  props: {
    inline: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Bezig…',
    },
  },
  computed: {
    classNames() {
      return ['ds-spinner', this.inline && 'ds-spinner--inline'].filter(Boolean)
    },
  },
}
</script>
